"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
function ResetButton(props) {
    const { onClick, disabled, tooltipPlace } = props;
    const { t } = (0, i18n_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(TooltipButton, { tooltip: {
            context: t(i18n_1.Strings.toolbar.resetScreenTooltip),
            place: tooltipPlace,
        }, onClick: onClick, disabled: disabled, "$flashOnClick": true, children: (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: ui_1.Icons.Reset_Main, width: 24, height: 24 }) }));
}
const TooltipButton = (0, ui_1.withTooltip)(ui_1.ToolBarBaseButton);
exports.default = ResetButton;
